import React from 'react';

interface FilterTagButtonProps {
    tag: string;
    selected: boolean;
    onToggle: (tag: string) => void;
    className?: string;
}

/**
 * Reusable tag filter button component used across workspace modals.
 * Provides consistent styling and behavior for tag filtering.
 */
export const FilterTagButton: React.FC<FilterTagButtonProps> = ({
                                                                    tag,
                                                                    selected,
                                                                    onToggle,
                                                                    className = '',
                                                                }) => {
    return (
        <button
            onClick={() => onToggle(tag)}
            className={`
        px-3 py-1 text-xs font-medium rounded-full transition-colors
        ${selected
                ? 'bg-blue-500 text-white'
                : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'}
        ${className}
      `}
        >
            {tag}
        </button>
    );
};

export default FilterTagButton;
